import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const AddComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg width="130" height="148" viewBox="0 0 130 148" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <linearGradient x1="49.967%" y1="-2.316%" x2="49.967%" y2="101.081%" id="nirt7ohw4c">
          <stop offset="0%" stopColor="#FDFEFF" />
          <stop offset="99.64%" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient x1="0%" y1="49.999%" x2="100%" y2="49.999%" id="a1kqhhmuld">
          <stop offset="0%" stopColor="#E4002B" />
          <stop offset="96%" stopColor="#A2002B" />
        </linearGradient>
        <filter
          x="-58.3%"
          y="-28.9%"
          width="216.6%"
          height="180.9%"
          filterUnits="objectBoundingBox"
          id="roza4s0zma"
        >
          <feOffset dy="11" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="11" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M96.527 87.3c-8.935 9.703-21.736 15.779-35.954 15.779a48.65 48.65 0 0 1-30.09-10.358V12.758c0-2.645 2.13-4.806 4.787-4.806h47.487l13.77 13.82v65.529z"
          id="69rqnfpgrb"
        />
      </defs>
      <g fill="none">
        <path
          d="M64.185 113.841c27.004 0 48.897-21.886 48.897-48.988s-21.99-48.996-48.897-48.996c-27.004 0-48.896 21.894-48.896 48.996 0 27.102 21.892 48.988 48.896 48.988zM117.513 34.83a3.953 3.953 0 0 0 3.954-3.955 3.958 3.958 0 0 0-3.954-3.954 3.958 3.958 0 0 0-3.954 3.954 3.953 3.953 0 0 0 3.954 3.955zM121.3 16.404a2.703 2.703 0 0 0 0-5.404 2.702 2.702 0 0 0 0 5.404zM22.506 22.732a2.697 2.697 0 1 0 0-5.396 2.698 2.698 0 1 0 0 5.396z"
          fill="#EAEEF9"
        />
        <path
          d="M9.015 86.815a5.015 5.015 0 0 0 5.015-5.019 5.013 5.013 0 0 0-5.015-5.011A5.013 5.013 0 0 0 4 81.796a5.015 5.015 0 0 0 5.015 5.02z"
          fill="#F1F3F9"
        />
        <g transform="translate(4 11)">
          <use fill="#000" filter="url(#roza4s0zma)" xlinkHref="#69rqnfpgrb" />
          <use fill="url(#nirt7ohw4c)" xlinkHref="#69rqnfpgrb" />
        </g>
        <path
          d="M53.801 97.31h-6.916c-.257 0-.464-.671-.464-1.474 0-.802.207-1.474.464-1.474h6.916c.258 0 .464.672.464 1.474 0 .934-.206 1.474-.464 1.474zM69.018 35.532H47.356c-.503 0-.935-.68-.935-1.474 0-.786.432-1.465.935-1.465h21.662c.504 0 .936.68.936 1.465 0 .794-.432 1.474-.936 1.474zM52.7 42.394h-5.647c-.34 0-.632-.68-.632-1.466 0-.794.292-1.474.632-1.474h5.598c.342 0 .633.68.633 1.474 0 .786-.291 1.466-.583 1.466zM86.881 80.64H48.122c-.36 0-.72.613-.72 1.465 0 .737.288 1.474.72 1.474h38.759c.361 0 .722-.614.722-1.474-.072-.852-.36-1.466-.722-1.466zM86.88 72.795H48.124c-.362 0-.723.614-.723 1.466 0 .737.29 1.474.723 1.474H86.88c.361 0 .723-.614.723-1.474-.072-.852-.362-1.466-.723-1.466zM87.91 65.926H48.14c-.37 0-.738.614-.738 1.473 0 .737.295 1.474.738 1.474H87.837c.368 0 .737-.614.737-1.474.074-.736-.295-1.473-.664-1.473zM87.852 58.082H48.133c-.366 0-.732.614-.732 1.473 0 .737.293 1.474.731 1.474H87.78c.512 0 .804-.614.804-1.474 0-.736-.292-1.473-.73-1.473zM86.37 19.295v10.546a3.274 3.274 0 0 0 3.275 3.276h11.313"
          fill="#D5DDEA"
        />
        <path
          d="M57.233 40.741V71.12c0 3.553-2.91 6.14-6.144 6.14h-1.617v8.082c0 1.94-2.263 2.587-3.557 1.294l-8.084-9.376H6.143C2.587 77.26 0 74.353 0 71.12V40.74c0-3.553 2.91-6.14 6.143-6.14H51.09c3.234 0 6.144 2.906 6.144 6.14z"
          fill="url(#a1kqhhmuld)"
          transform="translate(4 11)"
        />
        <path
          d="M19.198 67.577v-6.46c0-.975.646-1.622 1.616-1.622h7.114c.97 0 1.617.647 1.617 1.622v7.426c0 1.94 0 3.562-.324 4.847-.317 1.27-.945 1.916-1.882 2.858-.039.033-.08.073-.126.098-.808.508-2.033.819-3.506 1.08a.81.81 0 0 1-.953-.802v-1.228c0-.41.303-.745.696-.851 1.831-.475 2.861-1.753 2.861-4.062 0 0-.29-.646-.647-.646h-4.279a.816.816 0 0 1-.454-.14c-.897-.597-1.733-1.22-1.733-2.12zm15.843 0v-6.46c0-.975.647-1.622 1.617-1.622h7.114c.97 0 1.616.647 1.616 1.622v7.426c0 1.94 0 3.562-.323 4.847-.317 1.27-.944 1.916-1.883 2.858-.038.033-.079.073-.125.098-.808.508-2.034.819-3.507 1.08a.81.81 0 0 1-.952-.802v-1.228c0-.41.302-.745.697-.851 1.83-.475 2.86-1.753 2.86-4.062 0 0-.29-.646-.646-.646h-4.28a.816.816 0 0 1-.454-.14c-.896-.597-1.734-1.22-1.734-2.12z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};

AddComment.displayName = 'AddComment';
